import * as React from 'react';
import { Outlet } from 'react-router-dom';

import { PrivateLayout } from '@/components/Layout';

type PrivateLayoutContainerProps = {
  hiddenHeader?: boolean;
  hiddenFooter?: boolean;
  hiddenNotification?: boolean;
};

export const PrivateLayoutContainer = ({
  hiddenHeader = false,
  hiddenFooter = false,
  hiddenNotification = false,
}: PrivateLayoutContainerProps) => {
  return (
    <PrivateLayout
      hiddenHeader={hiddenHeader}
      hiddenFooter={hiddenFooter}
      hiddenNotification={hiddenNotification}
    >
      <Outlet />
    </PrivateLayout>
  );
};
